export default __webpack_public_path__ + "64d6f1f3ea14805d620fa830e3a5fea7.jpg";